(function ($) {
    "use strict";

    var $doc = $(document);

    $doc.on('click', '[href^="#"]', function (event) {
        if (event.isDefaultPrevented()) {
            return true;
        }

        var $this    = $(this),
            duration = $this.data('scrollspeed') || 350,
            href     = $this.attr('href') || '#',
            $target  = href != '#' && $(href) || false;

        if ($target && $target.length > 0) {
            event.preventDefault();

            $('html, body').stop().animate({
                scrollTop: $target.offset().top
            }, duration);
        }
    });

    // Stop smoothscroll animation on user interaction
    $doc.on('mousedown touchstart', function () {
        $('html, body').stop();
    });
})(window.jQuery);
